import { FC, useEffect } from "react";
import { useApp } from "../context/useApp";
import { ROUTES } from "../utils/symbols";
import { StepControls } from "../components/table-layout/aside/StepControls";
import { _ } from "../utils/helpers";
import { TicketSelectionWithoutTables } from "../components/TicketSelectionWithoutTables";
import { Aside } from "../components/personal-details/Aside";
import { ShiftSelectionWithoutTables } from "../components/ShiftSelectionWithoutTables";
import { Summary } from "../components/table-layout/aside/Summary";

export const TableLayoutPageWithoutTables: FC = () => {

    const {
        state: { booking, dialogHandles, screen },
        actions: { navigate }
    } = useApp()

    useEffect(() => {

        if(dialogHandles.size === 0) return
        
        if (booking.step === 'date') {navigate(ROUTES.DATE); return}
        if (booking.step === 'shift') {navigate(ROUTES.TABLE_LAYOUT); return}

    }, [])

    return (
            <main 
                id="" 
                className="page-container df aic jcc fd-c layout-b w-100 test-ab-page" 
                aria-label={_('3zo_tocon_i')}
            >
                <div className="h-100 w-100 df aifs jcsb px-10 zones layout-b-content">
                    <StepControls />
                    <Summary />
                    <ShiftSelectionWithoutTables />
                    <TicketSelectionWithoutTables />
                    {screen.width > 1000 && (<Aside stripeComplete={false} />)}
                </div>
            </main>
    )
}
